import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';
import styles from './styles.module.scss';

export function ShowCookiePopup() {
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    const isShowFromLocaleStorage = localStorage.getItem('hermitage-show-popup-cookie');
    setIsShow(isShowFromLocaleStorage === null);
  }, []);

  if (!isShow) return null;

  const closeShowPopup = () => {
    setIsShow(false);

    localStorage.setItem('hermitage-show-popup-cookie', 'true');
  }

  return (
    <div className={styles.container}>
      <p>Мы используем файлы cookie</p>
      <p>Для обеспечения оптимальной работы анализа, использования и улучшение пользовательского опыта
        на сайте используются технологии cookie. Продолжая пользоваться сайтом, Вы соглашаетесь
        с размещением cookie-файлов на вашем устройстве на условиях изложенных в <Link to='policy'>политике конфиденциальности</Link>
      </p>
      <Button onClick={closeShowPopup} className={styles.container_accept}>Принять</Button>
    </div>
  )
}
